import React, { useState, useEffect } from 'react';
import styles from './EditUnitPricing.module.scss';
import {
	TextField,
	TablePagination,
	FormControl,
	InputLabel,
	InputAdornment,
	OutlinedInput,
	FormHelperText,
	Button,
	IconButton,
} from '@material-ui/core';
import CustomButton from '../../../../layout/customButton/CustomButton';
import {
	updateBuildingInfoAllElevationsPrice,
	updateBuildingInfoSingleElevationPrice,
	updateBuildingInfoSingleElevationImg,
	updateBuildingInfoSingleElevationFloorplan,
	updateBuildingInfoSingleElevationOptions,
} from '../../../../../api/Siteplan/updateBuildingInfo.api';
import { connect } from 'react-redux';
import ClearIcon from '@material-ui/icons/Clear';
import Options from './options/Options';
import UnitHistory from '../../../history/UnitHistory';
import ConfirmationComponent from '../../../../confirmation/ConfirmationComponent';
import { setAlert } from '../../../../../redux/alerts/action';

const EditUnitPricing = (props) => {
	const [priceAddSubtract, setPriceAddSubtract] = useState('0');
	const [priceAddSubtractError, setPriceAddSubtractError] = useState(false);
	const [priceAddSubtractErrMsg, setPriceAddSubtractErrMsg] = useState('');
	const [elevationPrice, setElevationPrice] = useState('');
	const [elevationPriceError, setElevationPriceError] = useState(false);
	const [elevationPriceErrMsg, setElevationPriceErrMsg] = useState('');
	const [elevationPreviewImgArr, setElevationPreviewImgArr] = useState([]);
	const [floorplanFileArr, setFloorplanFileArr] = useState([]);
	const [optionArr, setOptionArr] = useState([
		{ name: '', price: '0', images: [] },
	]);
	const [unitConfirmationModal, setUnitConfirmationModal] = useState(false);
	const [unitElevationConfirmationModal, setUnitElevationConfirmationModal] =
		useState(false);

	const {
		unitIdArr,
		editUnitPricingPage,
		setEditUnitPricingPage,
		buildingInfo,
		elevationId,
		uid,
		setAlert,
	} = props;

	useEffect(() => {
		let priceArr = buildingInfo[
			unitIdArr[editUnitPricingPage]
		]?.priceList?.filter((item) => item.id === elevationId);
		if (priceArr?.length > 0) {
			// initialize the elevation price in the form
			setElevationPrice(priceArr[0].price);

			// initialize the elevation image in the form
			if (priceArr[0].images) {
				let tempElevationPreviewImgArr = [];
				priceArr[0].images.forEach((item) => {
					tempElevationPreviewImgArr.push({
						url: item.url,
						file: {
							name: item.name,
							onCloud: true,
						},
					});
				});
				setElevationPreviewImgArr(tempElevationPreviewImgArr);
			} else {
				setElevationPreviewImgArr([]);
			}

			// initialize the floor plan file in the form
			if (priceArr[0].floorplanFiles) {
				let tempFloorPlanFileArr = [];
				priceArr[0].floorplanFiles.forEach((item) => {
					tempFloorPlanFileArr.push({
						url: item.url,
						file: {
							name: item.name,
							onCloud: true,
						},
					});
				});
				setFloorplanFileArr(tempFloorPlanFileArr);
			} else {
				setFloorplanFileArr([]);
			}

			// initialize the options
			if (priceArr[0].options) {
				let tempOptionArr = [];
				priceArr[0].options.forEach((item) => {
					let tempImageArr = [];

					item?.images?.forEach((image) => {
						tempImageArr.push({
							url: image.url,
							file: {
								name: image.name,
								onCloud: true,
							},
						});
					});
					tempOptionArr.push({
						name: item.name,
						price: item.price,
						images: tempImageArr,
					});
				});
				setOptionArr(tempOptionArr);
			} else {
				setOptionArr([{ name: '', price: '0', images: [] }]);
			}
		}
	}, [unitIdArr, elevationId, editUnitPricingPage]);

	const handleChangePage = (event, newPage) => {
		setEditUnitPricingPage(newPage);
	};

	const handlePlus = () => {
		if (validatePriceValue(priceAddSubtract)) {
			clearPriceAddSubtractError();
			setPriceAddSubtract(Number(priceAddSubtract) + 5000);
		} else {
			setPriceAddSubtractError(true);
			setPriceAddSubtractErrMsg('Invalid number.');
		}
	};

	const handleSubtract = () => {
		if (validatePriceValue(priceAddSubtract)) {
			clearPriceAddSubtractError();
			setPriceAddSubtract(Number(priceAddSubtract) - 5000);
		} else {
			setPriceAddSubtractError(true);
			setPriceAddSubtractErrMsg('Invalid number.');
		}
	};

	const handleChange = (e) => {
		if (e.target.name === 'priceAddSubtract') {
			clearPriceAddSubtractError();
			let numRef = /^[\s\d]*$/;
			numRef.test(e.target.value) && setPriceAddSubtract(e.target.value);
		} else if (e.target.name === 'elevationPrice') {
			setElevationPrice(e.target.value);
			clearElevationPriceError();
		}
	};

	const handleEditUnit = () => {
		if (!validatePriceValue(priceAddSubtract) || !validatePositivePrice()) {
			if (!validatePriceValue(priceAddSubtract)) {
				setPriceAddSubtractError(true);
				setPriceAddSubtractErrMsg('Invalid number.');
			}
			if (!validatePositivePrice()) {
				setPriceAddSubtractError(true);
				setPriceAddSubtractErrMsg(
					'Subtracting value is greater than the current elevation price.'
				);
			}
		} else {
			updateBuildingInfoAllElevationsPrice(
				unitIdArr[editUnitPricingPage],
				Number(priceAddSubtract),
				uid
			);
			setAlert('success', 'Edit successfully.');
		}
	};

	const handleEditUnitElevation = () => {
		if (!validateElevationPriceValue(elevationPrice)) {
			setElevationPriceError(true);
			setElevationPriceErrMsg('Invalid price.');
		} else if (!validateOptionsPrice()) {
			setAlert('warning', 'Invalid option price.');
		} else {
			updateBuildingInfoSingleElevationPrice(
				unitIdArr[editUnitPricingPage],
				elevationId,
				Number(elevationPrice),
				uid
			);
			updateBuildingInfoSingleElevationImg(
				unitIdArr[editUnitPricingPage],
				elevationId,
				elevationPreviewImgArr
			);
			updateBuildingInfoSingleElevationFloorplan(
				unitIdArr[editUnitPricingPage],
				elevationId,
				floorplanFileArr
			);
			updateBuildingInfoSingleElevationOptions(
				unitIdArr[editUnitPricingPage],
				elevationId,
				optionArr
			);
			setAlert('success', 'Edit successfully.');
		}
	};

	const clearPriceAddSubtractError = () => {
		setPriceAddSubtractError(false);
		setPriceAddSubtractErrMsg('');
	};

	const clearElevationPriceError = () => {
		setElevationPriceError(false);
		setElevationPriceErrMsg('');
	};

	const validatePriceValue = (number) => {
		if (number === '') {
			return false;
		} else {
			if (!isNaN(number)) {
				return true;
			} else {
				return false;
			}
		}
	};

	const validateElevationPriceValue = (number) => {
		if (number === '') {
			return false;
		} else {
			if (!isNaN(number) && number >= 0) {
				return true;
			} else {
				return false;
			}
		}
	};

	const validateOptionsPrice = () => {
		for (let option of optionArr) {
			if (option.price === '') {
				return false;
			} else {
				if (isNaN(option.price) || option.price < 0) {
					return false;
				}
			}
		}
		return true;
	};

	const validatePositivePrice = () => {
		let result = true;
		buildingInfo[unitIdArr[editUnitPricingPage]]?.priceList?.forEach(
			(item) => {
				if (Number(item.price) + Number(priceAddSubtract) < 0) {
					result = false;
				}
			}
		);
		return result;
	};

	const handleAddElevationImg = (e) => {
		var imgType = e.target.files[0]?.type;
		if (
			imgType === 'image/png' ||
			imgType === 'image/jpeg' ||
			imgType === 'image/jpg' ||
			imgType === 'image/gif'
		) {
			setElevationPreviewImgArr([
				...elevationPreviewImgArr,
				{
					url: URL.createObjectURL(e.target.files[0]),
					file: e.target.files[0],
				},
			]);
		} else {
			setAlert('warning', 'Please upload .png or .jpeg or .jpg or .gif');
		}
		e.target.value = null;
	};

	const handleAddFloorplanFile = (e) => {
		var imgType = e.target.files[0]?.type;
		if (
			imgType === 'image/png' ||
			imgType === 'image/jpeg' ||
			imgType === 'image/jpg' ||
			imgType === 'image/gif'
		) {
			setFloorplanFileArr([
				...floorplanFileArr,
				{
					url: URL.createObjectURL(e.target.files[0]),
					file: e.target.files[0],
				},
			]);
		} else {
			setAlert('warning', 'Please upload .png or .jpeg or .jpg or .gif');
		}
		e.target.value = null;
	};

	const handleDeleteElevationImg = (url) => {
		let filteredImgArr = elevationPreviewImgArr.filter(
			(item) => item.url !== url
		);
		setElevationPreviewImgArr(filteredImgArr);
	};

	const handleDeleteFloorplanFile = (url) => {
		let filteredImgArr = floorplanFileArr.filter(
			(item) => item.url !== url
		);
		setFloorplanFileArr(filteredImgArr);
	};
	const closeUnitConfirmationModal = () => {
		setUnitConfirmationModal(false);
	};

	const openUnitConfirmationModal = () => {
		if (priceAddSubtract === '') setPriceAddSubtract(0);
		setUnitConfirmationModal(true);
	};

	const closeUnitElevationConfirmationModal = () => {
		setUnitElevationConfirmationModal(false);
	};

	const openUnitElevationConfirmationModal = () => {
		setUnitElevationConfirmationModal(true);
	};

	const unitConfirmationButtonList = [
		{
			name: 'cancel',
			action: () => {
				closeUnitConfirmationModal();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: '700',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Save changes',
			action: () => {
				handleEditUnit();
				closeUnitConfirmationModal();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--primary)',
				fontWeight: '700',
				width: '175px',
				height: '42px',
			},
		},
	];

	const unitElevationConfirmationButtonList = [
		{
			name: 'cancel',
			action: () => {
				closeUnitElevationConfirmationModal();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: '700',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Save changes',
			action: () => {
				handleEditUnitElevation();
				closeUnitElevationConfirmationModal();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--primary)',
				fontWeight: '700',
				width: '175px',
				height: '42px',
			},
		},
	];

	return (
		<div className={styles.edit_unit}>
			<div className={styles.history}>
				{!elevationId ? (
					<UnitHistory buildingId={unitIdArr[editUnitPricingPage]} />
				) : (
					<UnitHistory
						buildingId={unitIdArr[editUnitPricingPage]}
						elevationId={elevationId}
					/>
				)}
			</div>
			{!elevationId ? (
				<div className={styles.unit}>
					<div className={styles.header}>
						<h2 className={styles.title}>
							Edit {unitIdArr[editUnitPricingPage]}
						</h2>
						<TablePagination
							rowsPerPageOptions={[1]}
							component='div'
							count={unitIdArr.length}
							rowsPerPage={1}
							page={editUnitPricingPage}
							onPageChange={handleChangePage}
							labelRowsPerPage={
								<div
									style={{
										color: 'var(--text-high-emphasis)',
									}}
								>
									Rows per page
								</div>
							}
							nextIconButtonProps={{
								style: {
									padding: '0px',
								},
							}}
							backIconButtonProps={{
								style: {
									padding: '0px',
									marginLeft: '-10px',
								},
							}}
							SelectProps={{
								style: {
									border: '1px solid var(--text-mid-emphasis)',
									borderRadius: '4px',
									padding: '4px',
									marginRight: '10px',
								},
							}}
						/>
					</div>
					{buildingInfo[
						unitIdArr[editUnitPricingPage]
					]?.priceList?.map((item) => (
						<div className={styles.elevation}>
							<h3 className={styles.title}>
								Elevation {item.id}
							</h3>
							<TextField
								disabled
								className={styles.textfield}
								variant='outlined'
								value={item.price}
							/>
						</div>
					))}
					<FormControl
						variant='outlined'
						className={styles.textfield}
						error={priceAddSubtractError}
					>
						<InputLabel htmlFor='price-add-subtract'>
							Price adding or subtracting
						</InputLabel>
						<OutlinedInput
							id='price-add-subtract'
							className={styles.price_add_subtract}
							name='priceAddSubtract'
							value={priceAddSubtract}
							labelWidth={205}
							onChange={handleChange}
							inputProps={{
								autoComplete: 'off',
							}}
							startAdornment={
								<div>
									<CustomButton
										width={38}
										height={37}
										onClick={handleSubtract}
									>
										-
									</CustomButton>
								</div>
							}
							endAdornment={
								<div>
									<CustomButton
										width={38}
										height={37}
										onClick={handlePlus}
									>
										+
									</CustomButton>
								</div>
							}
						/>
						<FormHelperText>
							{priceAddSubtractErrMsg}
						</FormHelperText>
					</FormControl>
					<div className={styles.save_btn}>
						<CustomButton
							width={166}
							height={42}
							onClick={openUnitConfirmationModal}
						>
							Save
						</CustomButton>
					</div>
				</div>
			) : (
				<div className={styles.unit_elevation}>
					<div className={styles.header}>
						<h2 className={styles.title}>
							Edit {unitIdArr[editUnitPricingPage]} {elevationId}
						</h2>
						<TablePagination
							rowsPerPageOptions={[1]}
							component='div'
							count={unitIdArr.length}
							rowsPerPage={1}
							page={editUnitPricingPage}
							onPageChange={handleChangePage}
							labelRowsPerPage={
								<div
									style={{
										color: 'var(--text-high-emphasis)',
									}}
								>
									Rows per page
								</div>
							}
							nextIconButtonProps={{
								style: {
									padding: '0px',
								},
							}}
							backIconButtonProps={{
								style: {
									padding: '0px',
									marginLeft: '-10px',
								},
							}}
							SelectProps={{
								style: {
									border: '1px solid var(--text-mid-emphasis)',
									borderRadius: '4px',
									padding: '4px',
									marginRight: '10px',
								},
							}}
						/>
					</div>
					<div className={styles.price}>
						<h3 className={styles.title}>Price</h3>
						<TextField
							className={styles.textfield}
							variant='outlined'
							value={elevationPrice}
							name='elevationPrice'
							onChange={handleChange}
							error={elevationPriceError}
							helperText={elevationPriceErrMsg}
						/>
					</div>
					<div className={styles.elevation_img}>
						<div className={styles.header}>
							<h3 className={styles.title}>Elevation</h3>
							<input
								type='file'
								accept='image/*'
								style={{ display: 'none' }}
								id='elevation-image'
								onChange={handleAddElevationImg}
							/>
							<label htmlFor='elevation-image'>
								<Button
									variant='contained'
									component='span'
									className={styles.img_btn}
								>
									Add Image
								</Button>
							</label>
						</div>
						<div className={styles.body}>
							{elevationPreviewImgArr.map((item) => (
								<div className={styles.preview} key={item.url}>
									<div className={styles.image_section}>
										<img
											src={item.url}
											className={styles.image}
										/>
									</div>
									<div className={styles.name_section}>
										<p className={styles.name}>
											{item.file.name}
										</p>
										<IconButton
											size='small'
											onClick={() =>
												handleDeleteElevationImg(
													item.url
												)
											}
										>
											<ClearIcon fontSize='small' />
										</IconButton>
									</div>
								</div>
							))}
						</div>
					</div>
					<div className={styles.floorplan_file}>
						<div className={styles.header}>
							<h3 className={styles.title}>Floorplan files</h3>
							<input
								type='file'
								accept='image/*'
								style={{ display: 'none' }}
								id='floorplan-file'
								onChange={handleAddFloorplanFile}
							/>
							<label htmlFor='floorplan-file'>
								<Button
									variant='contained'
									component='span'
									className={styles.floorplan_btn}
								>
									Add Files
								</Button>
							</label>
						</div>
						<div className={styles.body}>
							{floorplanFileArr.map((item) => (
								<div className={styles.preview} key={item.url}>
									<div className={styles.image_section}>
										<img
											src={item.url}
											className={styles.image}
										/>
									</div>
									<div className={styles.name_section}>
										<p className={styles.name}>
											{item.file.name}
										</p>
										<IconButton
											size='small'
											onClick={() =>
												handleDeleteFloorplanFile(
													item.url
												)
											}
										>
											<ClearIcon fontSize='small' />
										</IconButton>
									</div>
								</div>
							))}
						</div>
					</div>
					<div className={styles.options}>
						<Options
							optionArr={optionArr}
							setOptionArr={setOptionArr}
						/>
					</div>
					<div className={styles.save_btn}>
						<CustomButton
							width={166}
							height={42}
							onClick={openUnitElevationConfirmationModal}
						>
							Save
						</CustomButton>
					</div>
				</div>
			)}
			{!elevationId ? (
				<ConfirmationComponent
					open={unitConfirmationModal}
					handleClose={closeUnitConfirmationModal}
					title='Are you sure	you want to save this changes on pricing?'
					buttonList={unitConfirmationButtonList}
				/>
			) : (
				<ConfirmationComponent
					open={unitElevationConfirmationModal}
					handleClose={closeUnitElevationConfirmationModal}
					title='Are you sure	you want to save this changes on pricing?'
					buttonList={unitElevationConfirmationButtonList}
				/>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	buildingInfo: state.siteplanManagement.buildingInfo,
	uid: state.signIn.uid,
});

export default connect(mapStateToProps, { setAlert })(EditUnitPricing);
